export abstract class RouteSegmentService {
    abstract getSegmentUrl(segmentName: string, params?: any): any;
}

export function RouteSegmentServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('$routeSegment');
}

export const RouteSegmentServiceProvider = {
    provide: RouteSegmentService,
    useFactory: RouteSegmentServiceFactory,
    deps: ['$injector']
};
